export default __webpack_public_path__ + "public/assets/images/22de751f0b7170c16d027269b2a430a2.png";